import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

export function getSysLogs(condition) {
  return request({
    url: cmsServerContext + '/sysLog/list',
    method: 'post',
    timeout: 300000,
    data: condition
  })
}
